import React from "react";
import "./Cargo.css";
import { FiSearch } from "react-icons/fi";
import { FaGlobeAfrica } from "react-icons/fa";
import { MdLocationOn } from "react-icons/md";

export default function Cargo() {
  return (
    <section className="cargo-wrap-cltgr">
      <div className="cargo-inner-cltgr">
        {/* Texte */}
        <div className="cargo-head-cltgr">
          {/* <h1 className="cargo-title-cltgr">
            Delivering Your Cargo <br />
            <span className="cargo-world-cltgr">
              <span className="cargo-world-ico-cltgr" aria-hidden="true">
                <FaGlobeAfrica />
              </span>
              Worldwide
            </span>
          </h1> */}

          <h1 className="cargo-title-cltgr">
            Envoyez vos cargos <br />
            <span className="cargo-world-cltgr">
                des États-Unis vers le Togo <span className="cargo-world-ico-cltgr" aria-hidden="true">
                <FaGlobeAfrica />
              </span>
            </span>
            </h1>

          <div className="cargo-form-cltgr" role="search" aria-label="Cargo search">
            <div className="cargo-input-cltgr">
              <span className="cargo-input-ico-cltgr" aria-hidden="true">
                <MdLocationOn />
              </span>
              <input
                className="cargo-field-cltgr"
                placeholder="FROM USA - NEW JERSEY"
                type="text"
                disabled={true}
              />
            </div>

            <div className="cargo-input-cltgr">
              <span className="cargo-input-ico-cltgr" aria-hidden="true">
                <MdLocationOn />
              </span>
              <input
                className="cargo-field-cltgr"
                placeholder="TO TOGO - LOME"
                type="text"
                disabled={true}
              />
            </div>

            
          </div>
        </div>

        {/* Visuel */}
        <div className="cargo-visual-cltgr">
          <div className="cargo-line-cltgr" aria-hidden="true">
            <span className="cargo-line-dot-cltgr" />
            <span className="cargo-line-arrow-cltgr" />
          </div>

          <div className="cargo-card-cltgr">
           
            <img
              className="cargo-img-cltgr"
              src="/cargo.png"
              alt="Cargo container"
              loading="lazy"
              onError={(e) => {
                // fallback si l'image n'existe pas
                e.currentTarget.src =
                  "https://via.placeholder.com/1200x700?text=Cargo+Image";
              }}
            />
          </div>

          <div className="cargo-shadow-cltgr" aria-hidden="true" />
        </div>
      </div>
    </section>
  );
}